/// <reference types="vite-plugin-pwa/client" />
import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { registerSW } from 'virtual:pwa-register'
import { ErrorBoundary } from '@/components/common/ErrorBoundary'
import { getSubdomain } from '@/utils/subdomain'
import { router, createSubdomainRouter } from './routes'
import { STORE } from '@/config/store'
import { cleanupLegacyServiceWorkers } from '@/utils/cleanupLegacySW'
import { installErrorBuffer } from '@/utils/errorBuffer'
import './styles/index.css'

// Capture console errors/warnings into a ring buffer as early as possible so
// bug reports can attach recent errors. Must run before app code executes.
installErrorBuffer()

// PWA auto-update — silently activate new service workers without prompting
registerSW({ immediate: true })

// One-shot cleanup of the static-HTML era /service-worker.js if any user
// still has it registered. Fire-and-forget; never blocks rendering.
void cleanupLegacyServiceWorkers()

// This build is a single-store storefront for Marine Tackle: the whole app is
// pinned to their store, so the app root renders their storefront (not the
// iSQROLL marketplace home). A real subdomain still wins if one is present.
//
// We pin by seller UID rather than slug. Resolving a slug requires a `list`
// query on /users, which iSQROLL's security rules deny to unauthenticated
// visitors (403 PERMISSION_DENIED) since the get/list split landed — so for a
// guest that lookup can never succeed. Reading /users/{uid} directly is
// allowed, and we already know the UID.
const subdomain = getSubdomain()
const activeRouter = subdomain
  ? createSubdomainRouter(subdomain)
  : createSubdomainRouter(STORE.slug, STORE.sellerId)
void router // marketplace router retained but unused in the pinned single-store build

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <RouterProvider router={activeRouter} />
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
